import { Button } from '@/components/common/Button';
import { Drawer, DrawerTrigger, DrawerContent, DrawerClose } from '@/components/common/Drawer';
import { WebBodyText16, WebCaption12 } from '@fintronners/react-ui/src/GlobalStyling/webTypography';
import { buttonVariants } from '@/components/common/Button/Button';
import cn from '@/utils/tailwind';

const displayStrings = {
  buy: 'Buy',
  sell: 'Sell',
  addHoldings: 'Add to your holdings.',
  removeHoldings: 'Remove part or all of this stock from your holdings.',
  trade: 'Trade',
  close: 'Close',
};

type TradeBottomSheetProps = {
  onSelectOption: (isSell?: boolean) => void;
  ownsSecurity?: boolean;
  buyDisabled?: boolean;
};

export const TradeBottomSheet = ({
  onSelectOption,
  ownsSecurity,
  buyDisabled,
}: TradeBottomSheetProps) => {
  return (
    <Drawer>
      <DrawerTrigger
        className={cn(
          buttonVariants({
            variant: 'primary',
            size: 'lg',
          }),
          'lg:hidden',
        )}
      >
        {displayStrings.trade}
      </DrawerTrigger>
      <DrawerContent className="border-b border-t px-4 ">
        <div className="border-b-grey25 border-b border-t-grey25 border-t py-4">
          <ul className="space-y-3 list-none">
            <li className="border border-grey6 rounded-md shadow-md">
              <DrawerClose asChild>
                <button
                  disabled={buyDisabled}
                  onClick={() => onSelectOption()}
                  className={cn('w-full p-4 text-start', buyDisabled ? 'opacity-70' : '')}
                >
                  <WebBodyText16.Bold className="text-darkestBlue">
                    {displayStrings.buy}
                  </WebBodyText16.Bold>
                  <WebCaption12.Regular className="text-grey72">
                    {displayStrings.addHoldings}
                  </WebCaption12.Regular>
                </button>
              </DrawerClose>
            </li>
            <li className="border border-grey6 rounded-md shadow-md">
              <DrawerClose asChild>
                <button
                  disabled={!ownsSecurity}
                  className={cn('w-full p-4 text-start', !ownsSecurity ? 'opacity-70' : '')}
                  onClick={() => onSelectOption(true)}
                >
                  <WebBodyText16.Bold className="text-darkestBlue">
                    {displayStrings.sell}
                  </WebBodyText16.Bold>
                  <WebCaption12.Regular className="text-grey72">
                    {displayStrings.removeHoldings}
                  </WebCaption12.Regular>
                </button>
              </DrawerClose>
            </li>
          </ul>
        </div>
        <DrawerClose className="py-4">
          <Button variant="ghost" size="lg">
            {displayStrings.close}
          </Button>
        </DrawerClose>
      </DrawerContent>
    </Drawer>
  );
};
